import { ITestInputObject } from '../../api/type-def';

export function findVariablesInPrompt(input: string): ITestInputObject {
	// Regular expression to match all substrings that start with {{$ and end with }}
	const regex = /\{\{\$(.*?)\}\}/g;
	const result: ITestInputObject = {};

	// Use matchAll to find all matches
	const matches = Array.from(input.matchAll(regex));

	// Use forEach to iterate over the matches array
	matches.forEach((match) => {
		// The match[1] contains the part between {{$ and }}
		result[match[1]] = '';
	});

	return Object.keys(result).length === 0 ? { text: '' } : result;
}

export function replaceVariablesInPrompt(
	prompt: string,
	values: ITestInputObject,
): string {
	// Regular expression to match all substrings that start with {{$ and end with }}
	const regex = /\{\{\$(.*?)\}\}/g;
	// Replace each placeholder with the corresponding value from the input object
	const result = prompt.replace(regex, (match, p1) => {
		// Check if the key exists in the values object
		if (values[p1] !== undefined) {
			return values[p1];
		}
		// If the key does not exist, return the placeholder as is or use an empty string
		return '';
	});

	return result;
}
